(function () {
  'use strict';
  var NS = 'http://www.w3.org/2000/svg';

  function money(fmt, cents) {
    var amt = cents / 100;
    var s;
    if (/amount_no_decimals/.test(fmt)) s = Math.round(amt).toLocaleString('en-IN');
    else s = amt.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s).replace(/<[^>]+>/g, '');
  }

  function init(root) {
    if (root.__upkcb) return;
    root.__upkcb = true;

    var cfg;
    try { cfg = JSON.parse(root.querySelector('[data-config]').textContent); } catch (e) { console.warn('upk-charm-bar: bad config', e); return; }
    var charms = (cfg.charms || []).filter(function (c) { return c && c.type; });
    var fmt = root.dataset.money || '₹{{amount}}';
    var showGuide = root.dataset.showGuide === 'true';
    var isMobile = function () { return window.matchMedia('(max-width:749px)').matches; };
    var initialCount = function () { return parseInt(isMobile() ? root.dataset.initialMobile : root.dataset.initialDesktop, 10) || 8; };

    var $ = function (sel) { return root.querySelector(sel); };
    var tray = $('[data-tray]'), more = $('[data-more]'), gCharms = $('[data-charms]'),
        guide = $('[data-guide]'), empty = $('[data-empty]'), chips = $('[data-chips]'), count = $('[data-count]'),
        price = $('[data-price]'), cta = $('[data-cta]'), reset = $('[data-reset]'), msg = $('[data-msg]'),
        letters = $('[data-letters]'), lettersGrid = $('[data-letters-grid]'), lettersClose = $('[data-letters-close]');

    var state = { base: root.dataset.defaultBase || 'necklace', selected: [], expanded: false };
    if (!cfg[state.base] || !cfg[state.base].variant) state.base = state.base === 'necklace' ? 'bracelet' : 'necklace';

    /* ---------- base toggle ---------- */
    var tabs = root.querySelectorAll('.upk-cb__tab');
    tabs.forEach(function (t) {
      var b = t.dataset.base;
      if (!cfg[b] || !cfg[b].variant) { t.hidden = true; return; }
      t.addEventListener('click', function () { setBase(b); });
    });
    function setBase(b) {
      state.base = b;
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t.dataset.base === b ? 'true' : 'false'); });
      root.querySelectorAll('[data-base-img]').forEach(function (img) { img.classList.toggle('is-active', img.dataset.baseImg === b); });
      var max = cfg[b].max || 5;
      if (state.selected.length > max) state.selected = state.selected.slice(0, max);
      renderPreview(); renderTray(); renderSummary();
    }

    /* ---------- tray ---------- */
    function renderTray() {
      var max = cfg[state.base].max || 5;
      var full = state.selected.length >= max;
      var n = initialCount();
      tray.innerHTML = '';
      charms.forEach(function (c, i) {
        var tile = document.createElement('button');
        tile.type = 'button';
        tile.className = 'upk-cb__tile' + (c.type === 'initials' ? ' upk-cb__tile--initials' : '');
        tile.dataset.i = i;
        var on = isSelected(c);
        if (on) tile.classList.add('is-on');
        if (!on && full) tile.classList.add('is-dim');
        if (c.type === 'charm' && c.avail === false) tile.classList.add('is-soldout');
        if (i >= n && !state.expanded) tile.hidden = true;
        var minPrice = c.type === 'initials' ? Math.min.apply(null, c.variants.map(function (v) { return v.price; })) : c.price;
        var sel = c.type === 'initials' ? state.selected.filter(function (s) { return s.bid === c.bid; }) : [];
        tile.innerHTML = (c.type === 'initials'
          ? '<span class="upk-cb__initial-glyph">' + (sel.length ? sel.map(function (s) { return s.letter; }).join('') : 'A–Z') + '</span>'
          : (c.img ? '<img src="' + c.img + '" alt="" loading="lazy">' : ''))
          + '<span class="upk-cb__tile-name">' + esc(c.name) + '</span>'
          + '<span class="upk-cb__tile-price">' + money(fmt, minPrice) + '</span>';
        tile.addEventListener('click', function () { onTile(c); });
        tray.appendChild(tile);
      });
      more.hidden = charms.length <= n;
      if (!more.dataset.more) more.dataset.more = more.textContent;
      more.textContent = state.expanded ? 'Show fewer' : more.dataset.more;
    }
    more.addEventListener('click', function () { state.expanded = !state.expanded; renderTray(); if (!state.expanded) tray.scrollIntoView({ block: 'start', behavior: 'smooth' }); });

    function isSelected(c) {
      return state.selected.some(function (s) { return s.bid === c.bid; });
    }
    function onTile(c) {
      if (c.type === 'initials') { openLetters(c); return; }
      if (c.avail === false) return;
      var idx = state.selected.findIndex(function (s) { return s.bid === c.bid; });
      if (idx > -1) { state.selected.splice(idx, 1); }
      else if (!canAdd()) return;
      else state.selected.push({ bid: c.bid, id: c.id, name: c.name, price: c.price, img: c.img });
      update();
    }
    function canAdd() {
      var max = cfg[state.base].max || 5;
      if (state.selected.length >= max) { flash((cfg.maxText || 'Max {max} charms').replace('{max}', max)); return false; }
      return true;
    }

    /* ---------- initials ---------- */
    function openLetters(c) {
      lettersGrid.innerHTML = '';
      c.variants.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'upk-cb__letter'; b.textContent = v.t;
        if (v.avail === false) b.disabled = true;
        var on = state.selected.some(function (s) { return s.id === v.id; });
        if (on) b.classList.add('is-on');
        b.addEventListener('click', function () {
          var idx = state.selected.findIndex(function (s) { return s.id === v.id; });
          if (idx > -1) state.selected.splice(idx, 1);
          else if (canAdd()) state.selected.push({ bid: c.bid, id: v.id, name: c.name + ' ' + v.t, letter: v.t, price: v.price, img: v.img });
          update(); openLetters(c);
        });
        lettersGrid.appendChild(b);
      });
      letters.hidden = false;
      if (isMobile()) letters.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
    lettersClose.addEventListener('click', function () { letters.hidden = true; });

    /* ---------- preview ---------- */
    function renderPreview() {
      var b = cfg[state.base];
      var c = b.curve, d = 'M' + c[0] * 10 + ' ' + c[1] * 10 + ' Q' + c[2] * 10 + ' ' + c[3] * 10 + ' ' + c[4] * 10 + ' ' + c[5] * 10;
      guide.setAttribute('d', d);
      guide.setAttribute('opacity', showGuide ? '1' : '0');
      var size = (b.charm || 12) * 10;
      var spacing = (b.gap || 10) * 10;
      var L = guide.getTotalLength();
      var n = state.selected.length;
      gCharms.innerHTML = '';
      empty.classList.toggle('is-hidden', n > 0);
      if (n > 1) spacing = Math.min(spacing, (L - size * .4) / (n - 1));
      state.selected.forEach(function (s, i) {
        var at = L / 2 + (i - (n - 1) / 2) * spacing;
        at = Math.max(size * .2, Math.min(L - size * .2, at));
        var p = guide.getPointAtLength(at);
        var p1 = guide.getPointAtLength(Math.max(0, at - 6)), p2 = guide.getPointAtLength(Math.min(L, at + 6));
        var ang = Math.atan2(p2.y - p1.y, p2.x - p1.x) * 180 / Math.PI * 0.7;
        var g = document.createElementNS(NS, 'g');
        g.setAttribute('class', 'upk-cb__charm');
        var r = document.createElementNS(NS, 'g');
        r.setAttribute('transform', 'rotate(' + ang.toFixed(2) + ' ' + p.x.toFixed(1) + ' ' + p.y.toFixed(1) + ')');
        if (s.img) {
          var im = document.createElementNS(NS, 'image');
          im.setAttribute('href', s.img); im.setAttributeNS('http://www.w3.org/1999/xlink', 'href', s.img);
          im.setAttribute('x', p.x - size / 2); im.setAttribute('y', p.y - size * .08);
          im.setAttribute('width', size); im.setAttribute('height', size);
          im.setAttribute('preserveAspectRatio', 'xMidYMin meet');
          r.appendChild(im);
        }
        g.appendChild(r);
        gCharms.appendChild(g);
      });
    }

    /* ---------- summary ---------- */
    function renderSummary() {
      var b = cfg[state.base];
      var total = (b.price || 0) + state.selected.reduce(function (a, s) { return a + s.price; }, 0);
      count.textContent = (state.selected.length ? state.selected.length + (state.selected.length === 1 ? ' charm' : ' charms') : 'No charms yet') + ' · ' + (b.title || state.base);
      price.textContent = money(fmt, total);
      chips.innerHTML = '';
      state.selected.forEach(function (s, i) {
        var ch = document.createElement('button');
        ch.type = 'button'; ch.className = 'upk-cb__chip';
        ch.innerHTML = (s.img ? '<img src="' + s.img + '" alt="">' : '') + esc(s.name) + '<i>×</i>';
        ch.addEventListener('click', function () { state.selected.splice(i, 1); update(); });
        chips.appendChild(ch);
      });
    }

    function update() { renderPreview(); renderTray(); renderSummary(); }
    function flash(t) { msg.textContent = t; clearTimeout(flash._t); flash._t = setTimeout(function () { msg.textContent = ''; }, 2600); }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

    reset.addEventListener('click', function () { state.selected = []; letters.hidden = true; update(); });

    /* ---------- cart ---------- */
    cta.addEventListener('click', function () {
      var b = cfg[state.base];
      if (!b.variant) return;
      var bundle = 'cb-' + Date.now().toString(36);
      var bname = (b.title || state.base) + (state.selected.length ? ' + ' + state.selected.map(function (s) { return s.name; }).join(', ') : '');
      // _upk_bundle_size records how many cart lines this bundle SHOULD have
      // (the base piece + every selected charm), up-cart-drawer.js's
      // syncBundleIntegrity() reads this to detect when a customer removes
      // just one component, so it can dissolve the rest of the now-broken
      // bundle instead of leaving it behind as an orphaned line. It was
      // missing here, so a Charm Bar bundle could never be auto-dissolved
      // (bouquet.js and upk-band-charm-builder.js already set this).
      var bundleSize = 1 + state.selected.length;
      var props = { _upk_bundle_id: bundle, _upk_bundle_name: bname, _upk_bundle_size: String(bundleSize) };
      var items = [{ id: b.variant, quantity: 1, properties: Object.assign({ 'Charms': state.selected.map(function (s) { return s.name; }).join(', ') || 'None' }, props) }];
      state.selected.forEach(function (s) { items.push({ id: s.id, quantity: 1, properties: Object.assign({ 'For': b.title || state.base }, props) }); });
      cta.disabled = true;
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); }).then(function (res) {
        cta.disabled = false;
        if (!res || res.status || res.errors) { flash((res && (res.description || res.message)) || 'Could not add to cart'); return; }
        openCart(res);
      }).catch(function () { cta.disabled = false; flash('Could not add to cart'); });
    });

    function openCart(res) {
      var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');

      function withDrawer(cb) {
        var existing = document.querySelector('cart-drawer');
        if (!existing) { cb(null); return; }
        if (window.customElements && customElements.get('cart-drawer')) { cb(existing); return; }
        var done = false;
        function finish() { if (done) return; done = true; cb(document.querySelector('cart-drawer')); }
        if (window.customElements && customElements.whenDefined) {
          customElements.whenDefined('cart-drawer').then(finish).catch(finish);
        }
        setTimeout(finish, 700);
      }

      function apply(state) {
        withDrawer(function (drawer) {
          if (!drawer) { window.location.href = root + 'cart'; return; }
          try { drawer.renderContents(state); } catch (e) { console.warn('upk-charm-bar: drawer render', e); }
          // Belt-and-braces: force the visible/open state ourselves. Dawn's own
          // open() adds these classes inside a bare setTimeout with no fallback,
          // which can race with our renderContents call and silently no-op.
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              drawer.classList.remove('is-empty');
              drawer.classList.add('animate', 'active');
              document.body.classList.add('overflow-hidden');
            });
          });
          setTimeout(function () {
            if (!drawer.classList.contains('active')) {
              try { drawer.open(); } catch (e) {}
              drawer.classList.add('animate', 'active');
              document.body.classList.add('overflow-hidden');
            }
          }, 500);
          flash(cfg.addedText || 'Added to cart');
          if (window.publish && window.PUB_SUB_EVENTS) { try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'upk-charm-bar', cartData: res }); } catch (e) {} }
        });
      }

      if (res.sections && res.sections['cart-drawer']) { apply(res); return; }
      fetch(root + '?sections=cart-drawer,cart-icon-bubble', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (sec) { apply({ id: res.items ? res.items[0].id : res.id, sections: sec }); })
        .catch(function () { window.location.href = root + 'cart'; });
    }

    window.addEventListener('resize', debounce(function () { renderTray(); }, 200));
    setBase(state.base);
  }

  function debounce(fn, ms) { var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); }; }
  function boot() { document.querySelectorAll('.upk-cb').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.upk-cb'); if (r) init(r); });
})();
